import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonService } from 'app/services/common.service';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { CommonAuthenticationService } from './../../services/common-authentication.service';
import { EnvService } from './../../services/env.service';
import { NotificationService } from './../../services/notification.service';
import { Component, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DraggableModalService } from '../shared/draggable-modal/draggable-modal.service';
import { ConfirmModalService } from '../shared/confirm-modal/confirm-modal.service';
import { TableHead } from '../../models';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-student-documents',
  templateUrl: './student-documents.component.html',
  styleUrls: ['./student-documents.component.scss']
})
export class StudentDocumentsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() dynamicStudentUserId: any;
  @Input() studentPartnerId;
  isModal = false;
  minimize: Function;
  hide: Function;
  documents = [];
  documentClasses: any;
  fileArray: any;
  selectedDocumentClassTypeId = '0';
  categoryType = '0';
  fileName: any;
  selectedCategoryName = '';
  bodyContent: string;
  selectCategoryFlag = false;
  showAddDocSection: any;
  currentPage = 1; // variable to store current page
  totalItems = 0; // variable to store total items
  maxSize = 50; // variable to store max size
  pageShow = false; // variable to check if pagination to be shown or not
  currentDocumentId;
  studentUserId: any;
  studentProfileId: any;
  partnerId: any;
  dynamicStudentIdFlag: any;
  tableHead: TableHead[] = [
    { title: 'File Name', field: 'name', sort: false },
    { title: 'File Type', field: 'type', sort: false },
    { title: 'Posted By', field: 'by', sort: false },
    { title: 'Date / Time', field: 'uploadDate', sort: false },
    { title: 'Action', isStatic: true }
  ];
  studentDocumentLoader = false;
  fileUploadResponse;
  currentUploadMessageId: number;
  currentUploadCategoryType: string;
  selectedCategoryOther: any;
  documentUserFileId = [];
  searchFilter: any;
  studentName: string;
  minimum: number;
  maximum: number;
  collegename: string;
  dueDate: string;
  typemessage: string;
  loginRole: string;
  subs: Subscription[] = [];
  loader = false;
  loginModule: string;

  constructor(
    private notificationService: NotificationService,
    private envService: EnvService,
    private _commonAuthService: CommonAuthenticationService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonService: CommonService,
    private _commonDataSharedService: CommonDataSharedService,
    public _router: Router,
    private draggableModalService: DraggableModalService,
    private confirmModalService: ConfirmModalService
  ) { }

  ngOnInit() {
    const localStorageData = this._commonAuthService.getLoginData();
    this.studentProfileId = localStorageData.profileId;
    this.partnerId = localStorageData.partnerId;
    this.loginRole = localStorageData.role;
    this.loginModule = localStorageData.module;
    this.studentUserId = this.loginModule === 'student' ? localStorageData.userId : JSON.parse(localStorage.getItem('studentLocalId'));

    if (!this.dynamicStudentIdFlag) {
      this.getDocumentCategory();
    }

    this.subs.push(
      this._commonDataSharedService.dynamicStudentDetailData
        .subscribe(
          (data: any) => {
            if (data && data.name) {
              this.studentName = data.name;
            }
          }),
      this._commonDataSharedService.updateStudentDocuments.subscribe(() => {
        this.getDocumentsList();
      })
    );
  }

  ngOnChanges() {
    if (this.dynamicStudentUserId && this.studentPartnerId) {
      this.dynamicStudentIdFlag = true;
      this.getDocumentCategory();
    } else {
      this.dynamicStudentIdFlag = false;
    }
  }

  /**
   *@ngdoc method
   *@name getReferenceTypeList
   *@methodOf reference-list.component
   *@description
   * - This is a method, which is used to get reference type list by api call
  */
  getDocumentsList() {
    if (this.isModal) {
      return;
    }
    if (this._router.url === '/coach/coachStudentDetail') {
      this.studentDocumentLoader = true;
    }
    const inputJson = {
      studentUserId: this.dynamicStudentUserId || this.studentUserId.toString(),
      classTypeId: this.selectedDocumentClassTypeId.toString(),
      page: this.currentPage,
      PageSize: this.maxSize
    };
    this.loader = true;
    this._commonRequestResponseService.post('student/documents', inputJson)
      .subscribe(
        (documentListJson: any) => {
          this.loader = false;
          this.studentDocumentLoader = false;
          if (documentListJson.items && documentListJson.items.length) {
            this.documents = documentListJson.items;
            this.categoryType = '0';
            this.pageShow = true;
            this.fileName = '';
            this.totalItems = documentListJson.totalItems;
          } else {
            this.documents = [];
          }
        },
        () => {
          this.studentDocumentLoader = false;
          this.loader = false;
          this.documents = [];
          this.fileName = '';
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  /**
   *@ngdoc method
   *@name setPage
   *@methodOf security.component
   *@description
   * - This is a method, which is used to set current page
  */
  setPage(pageNo: number) {
    this.currentPage = pageNo;
  };

  /**
   *@ngdoc method
   *@name pageChanged
   *@methodOf security.component
   *@description
   * - This is a method, which is call when page changed
  */

  pageChanged(event: any) {
    this.getDocumentsList();
  };

  documentDeleteConfirmation(item) {
    this.currentDocumentId = item.documentId;
    this.confirmModalService.open({
      ok: () => {
        this.documentDelete()
      },
      text: 'Are you sure you want to delete this document?',
      labels: ['Yes', 'Cancel']
    });
  }


  documentDelete() {
    this.loader = true;
    const inputJson = {
      studentUserId: this.dynamicStudentUserId || this.studentUserId.toString(),
      documentId: this.currentDocumentId
    };

    this._commonRequestResponseService.delete('student/document', inputJson)
      .subscribe(
        () => {
          this.loader = false;
          this.getDocumentsList();
          this.notificationService.show('success', 'Document deleted successfully');
          this._commonDataSharedService.updateMessageCount.next();
        },
        () => {
          this.loader = false;
          this.notificationService.show('error', 'Error while calling service');
        });
  }

  fileChangeEvent(fileInput) {
    this.fileName = fileInput.target.files[0].name;
    const reader = new FileReader();

    reader.onload = () => {
      const arrayBuffer: any = reader.result;
      const fileBytes = new Uint8Array(arrayBuffer);
      this.fileArray = fileBytes;
    };

    reader.readAsArrayBuffer(fileInput.target.files[0]);
  }

  uploadFile(form) {
    if (this.fileName && this.fileArray && this.fileArray.length > 0 /*&& this.selectCategoryFlag*/) {
      if (this.categoryType !== '0') {
        this.selectCategoryFlag = false;
        const inputJson = {
          studentUserId: this.dynamicStudentUserId || this.studentUserId.toString(),
          name: this.fileName,
          documentTypeClassId: form.value.categoryType,
          documentTypeClassName: this.selectedCategoryName,
          attachmentId: ''
        };

        const inputattachJson = {
          studentUserId: this.dynamicStudentUserId || this.studentUserId.toString(),
          fileName: this.fileName,
          file: this.fileArray.toString(),
          documentTypeClassId: form.value.categoryType,
        };
        this.loader = true;
        const serviceUrl = this._commonRequestResponseService.postWithHeader('shared/SaveStudentAttachment', inputattachJson);
        serviceUrl
          .subscribe(
            (responsedata: any) => {
              if (responsedata && responsedata.attachmentId) {
                this.currentUploadCategoryType = form.value.categoryType;
                inputJson.attachmentId = responsedata.attachmentId;
                this._commonRequestResponseService.postWithHeader('student/document', inputJson)
                  .subscribe(
                    (response: any) => {
                      this.loader = false;
                      this.fileUploadResponse = response;
                      this.showAddDocSection = !this.showAddDocSection;
                      this.fileName = response.name;
                      this.selectCategoryFlag = false;
                      this.documentUserFileId.push(responsedata.attachmentId);
                      this.notificationService.show('success', 'Document uploaded successfully!');
                      this._commonDataSharedService.updateMessageCount.next();
                      if (this.isModal) {
                        this._commonDataSharedService.updateStudentDocuments.next();
                      }
                      this.sendEssayAndAssignmentMessage();
                    },
                    () => {
                      this.loader = false;
                      this.notificationService.show('error', 'Error while uploading document');
                    });
              }

            },
            (error) => {
              this.loader = false;
              console.error(error)
            }
          );

      } else {
        this.selectCategoryFlag = true;
      }
    } else {
      this.notificationService.show('error', 'Please select file ');
    }
  }

  sendEssayAndAssignmentMessage() {
    if (this.selectedCategoryName === 'Essay') {
      this.bodyContent = `Word Count : ${this.minimum} - ${this.maximum}
      College Name : ${this.collegename}
     due date : ${new DatePipe('en-US').transform(this.dueDate, 'MM-dd-yyyy')}
     message : ${this.typemessage}`
    } else {
      this.bodyContent = `message : ${this.typemessage}`
    }
    const inputJson = {
      fromUserId: this.studentUserId.toString(),
      toUserId: '-1',
      subject: this.selectedCategoryName ? this.selectedCategoryName + ' Uploaded for Review' : '',
      threadId: '0',
      body: this.bodyContent,
      attachmentIds: this.documentUserFileId ? this.documentUserFileId : [],
    };

    this._commonRequestResponseService.post('shared/message', inputJson)
      .subscribe(
        (res: Response) => {
          this.currentUploadMessageId = res['messageId'];
          this._commonDataSharedService.updateMessageCount.next();
          if (this.hide) {
            this.hide();
          }

          this.getDocumentsList();

        }, () => {
          this.notificationService.show('error', 'Error while saving message data');
        });
  }

  getDocumentCategory() {
    const selectedType = {
      classTypeName: 'Document Type',
      partnerId: this.studentPartnerId || this.partnerId
    };

    this._commonRequestResponseService.postWithHeader('admin/values/', selectedType, ['partnerId'])
      .subscribe(
        (tempCategoryList: any) => {
          this.documentClasses = tempCategoryList.items;
          this.getDocumentsList();
        },
        () => {
          this.notificationService.show('error', 'Error while fetching document class data');
        });
  }

  onChange(categoryOptions) {
    this.selectedCategoryName = categoryOptions.options[categoryOptions.selectedIndex].text;

    for (let i = 0; i < this.documentClasses.length; i++) {
      if (this.documentClasses[i].text === this.selectedCategoryName.toString()) {
        this.selectedCategoryOther = this.documentClasses[i].other;
      }
    }

    this.selectCategoryFlag = this.selectedCategoryName !== '0';
  }

  readDocument(selectedItemObject) {
    if (!selectedItemObject.isRead) {
      this.loader = true;
      const inputJson = {
        documentId: selectedItemObject.documentId,
        isRead: 'true',
        partnerId: this.partnerId
      };

      this._commonRequestResponseService.postWithHeader('student/coachinghubmarkread', inputJson, ['partnerId'])
        .subscribe(
          () => {
            this.loader = false;
            selectedItemObject.isRead = true;
            this.notificationService.show('success', 'Document read successfully');
            this._commonDataSharedService.updateMessageCount.next();
          },
          () => {
            this.loader = false;
            this.notificationService.show('error', 'Error while fetching document class data');
          });
    }
  }
  uploadForm() {
    const isMobile = this.envService.getDevice() === 'mobile';
    const baseId = `modal-document-upload`;
    const header = `Document preview`;
    const modalUpload = this.draggableModalService.show({
      id: `${baseId}`,
      baseId,
      width: isMobile ? 300 : 700,
      trayTitle: header,
      initialState: {
        header,
        isModal: true,
        documentClassTypeList: this.documentClasses,
        documentListJson: this.documents,
        studentUserId: this.studentUserId
      }
    });
  }

  ngOnDestroy() {
    this.subs.forEach((sub: Subscription) => {
      sub.unsubscribe();
    });
  }
}
